<template>
    <section class="bg-lifeboost-green-300">
      <div class="mx-auto max-w-desktop xl:px-32">
        <div
          class="relative px-8 py-8 mx-auto text-center md:px-4 sm:py-8 md:py-10 sm:px-6 2xl:px-0 swiper-container"
        >
          <ClientOnly>
            <Swiper
              class="relative overflow-hidden"
              :autoplay="{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: false }"
              :modules="[SwiperNavigation, SwiperAutoplay]"
              :slidesPerView="2"
              :spaceBetween="10"
              :loop="true"
              :rewind="true"
              :breakpoints="{
                              1200: { slidesPerView: 5, spaceBetween: 30 },
                              900: { slidesPerView: 4, spaceBetween: 30 },
                              650: { slidesPerView: 2, spaceBetween: 40 },
                              300: { spaceBetween: 50 }
                          }"
            >
              <SwiperSlide v-for="(testimonial, index) in testimonials" :key="index">
                <div class="flex items-center justify-center">
                  <nuxt-img
                    sizes="xs:150px sm:170px md:208px lg:190px xl:190px 2xl:195px"
                    :src="testimonial.imgSrc"
                    :alt="testimonial.imgAlt"
                    class="object-cover mx-auto mix-blend-darken max-w-56 lg:max-w-52"
                    width="208"
                    height="65"
                    format="webp"
                    loading="lazy"
                  ></nuxt-img>
                </div>
              </SwiperSlide>
            </Swiper>
          </ClientOnly>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    testimonials: {
      type: Array,
      default: () => [
        {
          imgSrc: '/assets/images/logo-coffee-1-Photoroom.png',
          imgAlt: 'Logo Coffee 1',
        },
        {
          imgSrc: '/assets/images/logo-2-Photoroom.png',
          imgAlt: 'Logo 2',
        },
        {
          imgSrc: '/assets/images/logo-coffee-3-Photoroom.png',
          imgAlt: 'Logo Coffee 3',
        },
        {
          imgSrc: '/assets/images/logo-coffee-4-Photoroom.png',
          imgAlt: 'Logo Coffee 4',
        },
        {
          imgSrc: '/assets/images/logo-coffee-5-Photoroom.png',
          imgAlt: 'Logo Coffee 5',
        },
      ],
    },
  });
  
  defineBuilderComponent({
    friendlyName: 'Logos Swiper',
    inputs: [
      {
        name: 'testimonials',
        type: 'list',
        friendlyName: 'Logo List',
        subFields: [
          {
            name: 'imgSrc',
            type: 'file',
            friendlyName: 'Logo Image',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '',
          },
          {
            name: 'imgAlt',
            type: 'string',
            friendlyName: 'Image Alt Text',
            defaultValue: 'Logo Image',
          },
        ],
        defaultValue: [
          {
            imgSrc: '/assets/images/logo-coffee-1-Photoroom.png',
            imgAlt: 'Logo Coffee 1',
          },
          {
            imgSrc: '/assets/images/logo-2-Photoroom.png',
            imgAlt: 'Logo 2',
          },
          {
            imgSrc: '/assets/images/logo-coffee-3-Photoroom.png',
            imgAlt: 'Logo Coffee 3',
          },
          {
            imgSrc: '/assets/images/logo-coffee-4-Photoroom.png',
            imgAlt: 'Logo Coffee 4',
          },
          {
            imgSrc: '/assets/images/logo-coffee-5-Photoroom.png',
            imgAlt: 'Logo Coffee 5',
          },
        ],
      },
    ],
  });
  </script>
  
  <style>
  .swiper-container .swiper-wrapper {
    display: flex;
    align-items: center !important;
  }
  </style>
  